/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Save_Draft1Inputs */

const vi_cmspost_save_draft1 = /** @type {(inputs: Cmspost_Save_Draft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu nháp`)
};

/**

* @param {Cmspost_Save_Draft1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_save_draft1 = /** @type {((inputs?: Cmspost_Save_Draft1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Save_Draft1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_save_draft1(inputs)
});
export { cmspost_save_draft1 as "cmsPost_save_draft" }